import { ChoiceModel } from "../../../models/ChoiceModel";

export interface CarrouselScaleAnchorLabelIds {
    leftId?: string;
    rightId?: string;
}

export function getCarrouselScaleChoiceAriaLabelledBy(
    choice: ChoiceModel,
    choiceIndex: number,
    choiceCount: number,
    scaleAnchorLabelIds?: CarrouselScaleAnchorLabelIds,
): string | undefined {
    if (!scaleAnchorLabelIds) {
        return undefined;
    }
    const hasEndpointAnchor =
        (choiceIndex === 0 && scaleAnchorLabelIds.leftId) ||
        (choiceIndex === choiceCount - 1 && scaleAnchorLabelIds.rightId);
    if (!hasEndpointAnchor) {
        return undefined;
    }
    const labelId = `${choice.elementId}_LABEL`;
    const ids: string[] = [];
    if (choiceIndex === 0 && scaleAnchorLabelIds.leftId) {
        ids.push(scaleAnchorLabelIds.leftId);
    }
    ids.push(labelId);
    if (choiceIndex === choiceCount - 1 && scaleAnchorLabelIds.rightId) {
        ids.push(scaleAnchorLabelIds.rightId);
    }
    return ids.join(" ");
}
